import {
  FeedHeadline,
  FeedsService,
  GoogleRssTopic,
  Language,
  LanguageLevel
} from '@shared/openapi/jaaluu-api';
import { ref, Ref } from 'vue';
export default () => {
  const maxLoadFeeds: Ref<Record<GoogleRssTopic, number> | null> = ref(null);
  const allFeeds: Ref<Record<GoogleRssTopic, FeedHeadline[]>> = ref({
    [GoogleRssTopic.BUSINESS]: [],
    [GoogleRssTopic.ENTERTAINMENT]: [],
    [GoogleRssTopic.HEALTH]: [],
    [GoogleRssTopic.NATION]: [],
    [GoogleRssTopic.SCIENCE]: [],
    [GoogleRssTopic.SPORTS]: [],
    [GoogleRssTopic.TECHNOLOGY]: [],
    [GoogleRssTopic.WORLD]: []
  });

  const getCleanTitle = (news: FeedHeadline) => {
    if (!news) return '';
    return news.title.replace(` - ${news.source}`, '');
  };

  const loadFeeds = (
    topic: GoogleRssTopic,
    langForeign: Language,
    langLevel: LanguageLevel,
    _feeds: FeedHeadline[]
  ) => {
    return FeedsService.getFeedHealinesV1FeedsGet({
      query: {
        foreign: langForeign,
        lang_level: langLevel,
        topic
      },
      throwOnError: true
    }).then((res: any) => {
      _feeds.push(...res.data);
    });
  };

  const searchFeeds = (
    topic: GoogleRssTopic,
    q: string,
    langForeign: Language,
    langLevel: LanguageLevel,
    _feeds: FeedHeadline[]
  ) => {
    return FeedsService.searchArticleV1FeedsSearchGet({
      query: {
        topic,
        foreign: langForeign,
        lang_level: langLevel,
        q
      },
      throwOnError: true
    }).then((res: any) => {
      _feeds.push(...res.data);
    });
  };
  return { state: { maxLoadFeeds, allFeeds }, funcs: { getCleanTitle, loadFeeds, searchFeeds } };
};
